document.addEventListener('facetwp-loaded', function () {
  const content = document.getElementById('content');

  const facet_selections = document.querySelector('.facetwp-selections');
  facet_selections?.classList.remove('pointer-events-none');

  const facets = document.querySelectorAll('.facetwp-facet');
  for (let i = 0; i < facets.length; i++) {
    const facet = facets[i];
    const facet_name = facet.getAttribute('data-name');
    const facet_type = facet.getAttribute('data-type');
    const facet_label = FWP.settings.labels[facet_name];
    // facet.parentNode.style.display = 'block';
    const blacklist = [
      'reset',
      'result_counts',
      'future_lot',
      'sorting',
      'sorting_ho',
      // "buy_it_now",
      'location',
      'pagination',
      'load_more',
    ];

    if (facet_name == 'location') {
      facet.classList.add(
        'grid',
        'md:grid-cols-2',
        'lg:grid-cols-3',
        '2xl:grid-cols-5',
        'gap-5',
        'md:gap-4',
      );
      Array.from(facet.children).forEach((el, index) => {
        if (index == 0) {
          el.classList.add('hidden');
          return;
        }
        const classes = ['btn-shadow-lg'];
        if (!el.classList.contains('checked')) {
          classes.push('border-raven-lighter', 'font-normal');
        }
        el.classList.add(...classes);
      });
    }

    if (!blacklist.includes(facet_name) && !facet.closest('.facet-wrap')) {
      const classes = ['facet-wrap', 'mt-5', 'facet-wrap-' + facet_type];

      if (
        facet_type === 'fselect' &&
        facet_label === facet.querySelector('.fs-label').textContent
      ) {
        facet.querySelector('.fs-label').classList.add('non-selected');
      }

      const wrapper = document.createElement('div');
      wrapper.className = classes.join(' ');
      wrapper.setAttribute('data-for', facet_name);
      const label = document.createElement('label');
      label.className = 'facet-label';
      label.textContent = facet_label;
      wrapper.appendChild(label);
      facet.parentNode.insertBefore(wrapper, facet);
      wrapper.appendChild(facet);
    }

    if (facet_type !== 'pager' && facet_type !== 'sort') {
      if (!facet.closest('.facet-wrap') && !facet.closest('.facetwp-flyout')) {
        // Do nothing
      } else if (
        FWP.settings.num_choices[facet_name] !== undefined &&
        FWP.settings.num_choices[facet_name] <= 0
      ) {
        const wrapper = document.querySelector(
          '.facet-wrap[data-for="' + facet_name + '"]',
        );
        if (wrapper) {
          wrapper.style.display = 'none';
        }
      }
    }
  }

  for (const key in FWP.settings.num_choices) {
    if (Object.hasOwnProperty.call(FWP.settings.num_choices, key)) {
      const val = FWP.settings.num_choices[key];
      const facet = document.querySelector('.facetwp-facet-' + key);
      if (facet === null) {
        continue;
      }
      const flyout = facet.closest('.flyout-row');
      const wrapper = facet.closest('.facet-wrap');
      if (wrapper || flyout) {
        const target = wrapper ? wrapper : flyout;
        if (val === 0) {
          target.style.display = 'none';
        } else {
          target.style.display = key == 'buy_it_now' ? 'flex' : 'block';
        }
      }
    }
  }

  if (FWP.loaded && FWP.load_more_paged == 1 && content) {
    const top = content.offsetTop;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  if (theme.page.is_lot_cat) {
    document.querySelector('.facetwp-reset')?.addEventListener('click', (e) => {
      e.preventDefault();
      window.location = theme.pages.catalog.url;
    });
  }

  const query = FWP.buildQueryString() ? '?' + FWP.buildQueryString() : '';
  const selectFilterMake = document.getElementById('filter-make');
  const selectFilterModel = document.getElementById('filter-model');
  const selections = document.querySelectorAll('.eridanfacet-selections a');

  if (selectFilterMake) {
    selectFilterMake.dataset.link = selectFilterMake.dataset.link + query;

    selections.forEach((el) => (el.href = el.dataset.linkDefault + query));

    for (let option of selectFilterMake.options) {
      option.dataset.link = option.dataset.linkDefault + query;
    }

    selectFilterModel.dataset.link = selectFilterModel.dataset.link + query;
    for (let option of selectFilterModel.options) {
      option.dataset.link = option.dataset.linkDefault + query;
    }
    selectFilterMake.tomselect.sync();
    selectFilterModel.tomselect.sync();
  }

  // Змінювати кількість лотів під час фільтрації і робити disabled там де 0
  // В POLESTAR попали авто MAZDA 2
});

document.addEventListener('facetwp-refresh', function () {
  if (FWP.facets['make'] && FWP.facets['make'].length == 0) {
    FWP.facets['model'] = []; // Reset this facet
  }
  document
    .querySelector('.facetwp-selections')
    ?.classList.add('pointer-events-none');
  if (
    FWP.active_facet &&
    fUtil(FWP.active_facet.nodes[0]).attr('data-name') != 'load_more'
  ) {
    const container = document.querySelector('.facetwp-template');
    const skeleton = document
      .getElementById('lot-skeleton-wrap')
      .querySelector('li');

    container
      .querySelectorAll('li[data-lot]:not(.form-swat)')
      ?.forEach((element) => {
        // Create a clone of the skeleton element
        const skeletonClone = skeleton.cloneNode(true);
        skeletonClone.style.height = element.clientHeight + 'px';
        // Replace the current element with the clone
        container.replaceChild(skeletonClone, element);
      });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  document
    .querySelector('.eridanfacet-selections')
    ?.addEventListener('click', () => {
      document
        .querySelector('.eridanfacet-selections')
        .classList.add('pointer-events-none');
    });

  document
    .getElementById('filter-make')
    ?.tomselect.on('change', function (value) {
      let url;
      if (value == '') {
        url = document.getElementById('filter-make').dataset.link;
      } else {
        url = document.querySelector(`[value=${value}]`).dataset.link;
      }
      location.href = url;
    });

  document
    .getElementById('filter-model')
    ?.tomselect.on('change', function (value) {
      let url;
      if (value == '') {
        url = document.getElementById('filter-model').dataset.link;
      } else {
        url = document.querySelector(`[value='${value}']`).dataset.link;
      }
      location.href = url;
    });
});
